/**
 * 单选
 * type=1
 * 7-客户 8-项目 9-文档 12-币种 16-流程 24-岗位 24-岗位 28-会议
 * 29-奖惩种类 30-学历 31-用工性质 35-业务合同 36-合同性质 38-相关产品 52-公文种类
 * 53-紧急程度 54-秘密等级 55-发文字号 59-称呼 60-客户类型 61-客户描述
 * 62-客户规模 69-计量单位 87-会议室 89-会议类型 119-专业 129-项目模板
 * 165-分权单人力资源 178-年份 244-项目类型 245-工作类型 260-职称 262-办公地点 274-商机来源
 * 279-合同 281-职务类别 282-职务 284-工资银行 285-主题分类 300-预算项 388-班次
 * type=2
 * 32-培训安排 259-语言 388-班次
 * type=3
 * 4-部门 22-报销费用类型 25-资产组 63-行业 164-分部 167-分权单部门 169-分权单分部 251-成本中心
 * 1-人力资源
 */
export const singleBrowser = [
  1,
  7,
  8,
  9,
  12,
  16,
  24,
  28,
  29,
  30,
  31,
  35,
  36,
  38,
  52,
  53,
  54,
  55,
  59,
  60,
  61,
  62,
  69,
  87,
  89,
  119,
  129,
  165,
  178,
  179,
  244,
  245,
  260,
  262,
  274,
  279,
  281,
  282,
  284,
  285,
  300,
  388,
  32,
  259,
  4,
  22,
  25,
  63,
  164,
  167,
  169,
  251
];

/**
 * 多选
 * type=1
 * 18-多客户, 37-多文档, 65-多角色 135-多项目 152-多流程 160-角色人员 166-分权多人力资源 171-归档流程 278-多岗位 293-多发票 314-多资产资料 315-多资产
 * type=3
 * 57-多部门 142-收（发）文单位  162-自定义多选 168-分权多部门 170-分权多分部 194-多分部
 */
export const multipleBrowser = [
  17,
  18,
  37,
  65,
  135,
  152,
  160,
  166,
  171,
  278,
  293,
  314,
  315,
  57,
  142,
  162,
  168,
  170,
  194
];

/**
 * 显示checkbox
 * isMultCheckbox = true
 * 27-应聘人 268-星期多选 269-提醒方式
 */
export const checkboxBrowser = [27, 268, 269];
/**
 * 特殊浏览框
 * 2-日期，19-时间，290-日期时间
 */
export const specialBrowser = [2, 19, 290];

// 判断浏览框的类型是否为改造的
export function useTest() {
  const {
    type,
    isUseTest = true,
    hasRadio,
    isSingle,
    isMultCheckbox
  } = this.props;
  const _type = Number(type);
  let flag = false;
  if (singleBrowser.indexOf(_type) !== -1) {
    if (_type === 16 && hasRadio) {
      return false;
    }
    flag = true;
  } else if (multipleBrowser.indexOf(_type) !== -1) {
    flag = true;
  } else if (_type === 161) {
    // 自定义 161-自定义单选
    const {
      dataParams: { type }
    } = this.props;
    flag = type === "browser.belongmoud";
  } else if (_type === 23 || _type === 179) {
    /**
     * 树表类型
     * 23-资产 179-资产资料
     */
    flag = isSingle;
  } else if (specialBrowser.indexOf(_type) !== -1) {
    flag = true;
  } else {
    flag = false;
  }
  flag = isUseTest && flag && !isMultCheckbox;
  return flag;
}



// WEBPACK FOOTER //
// ./ecology9/wea-browser-test/isUseTest.js